<template>
  <div class="no-box-shadow-card">
    <div class="card border-color-select border-top-none"
         v-for="(ressource, index) of ressourceADate"
         :key="index">
      <div class="card-header">
        <a class="card-header-icon mgh-20px pdh-0 height-60"
           @click="ressource.isOpen = !ressource.isOpen ">
          <b-icon :icon="ressource.isOpen ? 'chevron-down' : 'chevron-right'"></b-icon>
        </a>
        <div class="columns is-marginless  mgt-20px full-width">
          <div class="column is-paddingless is-3">
            <div class="columns is-multiline">
              <div class="column is-12 pdv-0
              is-size-6 has-text-weight-bold has-text-link">
                {{ ressource.datePlanification | formatDate }}
              </div>
              <div class="column is-12 pdv-0 is-size-7 has-text-default">
                {{ $t('chargeTravailTech.ressourceAndAffectationInfo.nbOts',
                { nbOt: ressource.nbOts }) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-content pd-0"  v-if="ressource.isOpen">
        <div class="content">
          <detail-ot :ots="ressource.ots"></detail-ot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import detailOt from '@/components/logistique/chargeTravail/tech/ressource/detailOt';

export default {
  props: {
    ressourceADate: {
      type: Array,
      required: true,
    },
  },
  components: {
    detailOt,
  },
};

</script>
